export function hexToRGB(hex: string) {
  const clean = hex.replace('#','');
  const r = parseInt(clean.substring(0,2), 16);
  const g = parseInt(clean.substring(2,4), 16);
  const b = parseInt(clean.substring(4,6), 16);
  return { r, g, b };
}

export function shade(hex: string, percent: number) {
  const { r, g, b } = hexToRGB(hex);
  return `rgb(${Math.max(0, r + percent)}, ${Math.max(0, g + percent)}, ${Math.max(0, b + percent)})`;
}

export function applyTheme(color: string, isDark: boolean) {
  const root = document.documentElement;
  const { r, g, b } = hexToRGB(color);

  root.style.setProperty('--primary', color);
  root.style.setProperty('--primaryHover', shade(color, -30));
  root.style.setProperty('--primaryLight', `rgba(${r}, ${g}, ${b}, 0.1)`);
  root.style.setProperty('--focusGlow', `rgba(${r}, ${g}, ${b}, 0.4)`);

  root.style.setProperty('--background', isDark ? '#1e1e1e' : '#ffffff');
  root.style.setProperty('--backgroundGradient',
    isDark ? 'linear-gradient(135deg, #121212, #1e1e1e)' : 'linear-gradient(135deg, #f5f5f5, #ffffff)'
  );

  root.style.setProperty('--text', isDark ? '#ffffff' : '#333333');
  root.style.setProperty('--border', isDark ? '#3a3a3a' : '#e0e0e0');

  const homeGradient = `
    linear-gradient(
      -45deg,
      ${shade(color, -40)} 0%,
      ${shade(color, -20)} 20%,
      ${color} 40%,
      ${shade(color, +20)} 60%,
      ${shade(color, +40)} 80%,
      ${shade(color, +60)} 100%
    )
  `;
  root.style.setProperty('--homeGradient', homeGradient);
}

